import { z } from 'zod';
import type { ReaderPlannedCounts, ReaderPlannedPage } from '@sessions/readerPlanned';
import type { Session } from './client';

const count = z.number().int().nonnegative();

/** Строка сессии: проверяются поля, по которым идёт порядок списка (курсор и вставка из сокета); остальное — как у всех сессий */
const sessionRow = z.looseObject({ id: z.string(), date: z.string(), start: z.string() });

/** Ответ GET /sessions/reader-planned — порция «В других проектах» */
export const readerPlannedPageSchema: z.ZodType<ReaderPlannedPage<Session>> = z.object({
  items: z.array(z.custom<Session>((v) => sessionRow.safeParse(v).success)),
  nextCursor: z.string().nullable(),
});

/** Ответ GET /sessions/reader-planned/counts */
export const readerPlannedCountsSchema: z.ZodType<ReaderPlannedCounts> = z.object({
  total: count,
  byReader: z.record(z.string(), count),
});
